import React, { FC, Dispatch, SetStateAction } from 'react';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Dialog from '@mui/material/Dialog';
import Button from '@mui/material/Button';

import axios from '../../../sharedModules/utils/axios.utils';

interface ReqeustCompleteModalProps {
  issueReportToMarkId: string;
  issueCompleteModalOpen: boolean;
  setIssueCompleteModalOpen: Dispatch<SetStateAction<boolean>>;
  setIssueReports: Dispatch<SetStateAction<any>>;
}

const IssueCompleteModal: FC<ReqeustCompleteModalProps> = (props) => {
  let { issueReportToMarkId, issueCompleteModalOpen, setIssueCompleteModalOpen, setIssueReports } = props;

  const handleMarkComplete = async (row) => {
    let response: any = await axios.put(`/issue_reports/${issueReportToMarkId}`, { status: 'Reviewed' });
    setIssueReports(response.data.result);
    setIssueCompleteModalOpen(false);
  };

  return (
    <Dialog open={issueCompleteModalOpen} onClose={() => setIssueCompleteModalOpen(false)}>
      <Grid container spacing={2} style={{ minWidth: '400px', padding: '30px' }}>
        <Grid item xs={12}>
          <Typography variant="h5">Mark Request Reviewed</Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography variant="h6">Mark this request as reviewed?</Typography>
        </Grid>
        <Grid item xs={4}>
          <Button variant="contained" onClick={handleMarkComplete} color="warning">
            Mark Reviewed
          </Button>
        </Grid>
        <Grid item xs={3}>
          <Button variant="contained" onClick={() => setIssueCompleteModalOpen(false)} color="secondary">
            Cancel
          </Button>
        </Grid>
      </Grid>
    </Dialog>
  );
};

export default IssueCompleteModal;
